import { ReactComponent as AboutIcon } from "@icons/ha-smiley.svg";
import { AccountNavButton, AccountNavLink } from "./Components/AccountNavItem";
import { ReactComponent as ChangePasswordIcon } from "@icons/change-password.svg";
import { ReactComponent as ContactIcon } from "@icons/mail.svg";
import { ReactComponent as InfoIcon } from "@icons/info.svg";
import { ReactComponent as QuestionIcon } from "shared/assets/Icons/refresh/question.svg";
import PageTitle from "UIPalette/PageTitle/PageTitle";
import { ReactComponent as PersonalDetailsIcon } from "@icons/account.svg";
import { ReactComponent as PreferencesIcon } from "@icons/settings.svg";
import { ReactComponent as AccessibilityIcon } from "shared/assets/Icons/refresh/accessibility.svg";
import { useAuthVersioning } from "core/hooks/useAuthVersioning";
import { useTranslation } from "react-i18next";
import { useMobilePlatform } from "core/hooks/useMobilePlatform";

export const Account = () => {
  const { t } = useTranslation();
  const { appVersion } = useMobilePlatform();
  const { Logout } = useAuthVersioning();
  const isMobileApp = !!window.flutter_inappwebview;

  return (
    <>
      <PageTitle title={t("pageTitle.account.home")} />
      <div className="mt-6 col-span-full">
        {!process.env.REACT_APP_DISABLE_COMPONENTS_PAGE && <AccountNavLink to={"/components"} text={t("account.components")} Icon={InfoIcon} />}
        <AccountNavLink to={"/personal-details"} text={t("account.personalDetails")} Icon={PersonalDetailsIcon} />
        <AccountNavLink to={"/preferences"} text={t("account.preferences")} Icon={PreferencesIcon} />
        <AccountNavLink to={"/account-security"} text={t("account.accountSecurity")} Icon={ChangePasswordIcon} />
        <AccountNavLink to={"/customer-solutions"} text={t("account.contactSupport")} Icon={ContactIcon} />
        {isMobileApp && <AccountNavButton text={"Accessibility"} Icon={AccessibilityIcon} onClick={() => window.interdeal?.a11y.openMenu()} />}
        <AccountNavLink to={"/about-us"} text={t("account.about")} Icon={AboutIcon} />
        <AccountNavLink to={"/faqs"} text={t("account.faqs")} Icon={QuestionIcon} />
        <AccountNavLink to={"/terms-and-conditions"} text={t("account.terms")} Icon={InfoIcon} />
        <AccountNavLink to={"/privacy-policy"} text={t("account.privacy")} Icon={InfoIcon} />
        <AccountNavLink to={"/account-cookie-policy"} text={t("account.cookiePolicy")} Icon={InfoIcon} />
        <Logout type="account" />
      </div>
      {appVersion && (
        <p className="mt-6 text-center">
          Version: <span className="font-bold">{appVersion}</span>
        </p>
      )}
    </>
  );
};
